import Swiper from 'swiper'

export default function index(){

}